import {
  TypeformField,
  WorkFocusTypeformData,
  WorkFocusedPlanTypeformFieldRef,
} from '../schemas';

export class WorkFocusedPlanTypeformHelper {
  constructor(private readonly form?: WorkFocusTypeformData | null) {}

  getFormValue = (ref?: string) => {
    if (!this.form) {
      return undefined;
    }

    const field = Object.values(this.form).find(
      (field) => (field as TypeformField | undefined)?.ref === ref,
    ) as TypeformField | undefined;

    return field?.value;
  };

  getFatigue() {
    return this.getFormValue(WorkFocusedPlanTypeformFieldRef.Fatigue);
  }

  getRtwSe() {
    return this.form?.var_rtw_se;
  }
}
